import { render, staticRenderFns } from "./PersonaCreate.vue?vue&type=template&id=51cdde90&scoped=true&"
import script from "./PersonaCreate.vue?vue&type=script&lang=js&"
export * from "./PersonaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cdde90",
  null
  
)

export default component.exports